export default{
	name : 'health_dialog',
	props:{
		show : Boolean
	},
	data () {
		return {}
	},
	methods : {
		close() {
			this.$emit('close');
		},
		jkzx() {
			window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3dopenid%26redirect%3dservice.csjk%26type%3dparams%26params%3dopenId&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
		},
		xlzx() {
			// window.location.href = "http://w.5xwy.com/96111";
			window.location.href='https://user.cs96111.com/ad/record/url/auth?data=10;30;1';
		},
		cszb() {
			// window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3dopenid%26redirect%3dservice.cszb%26type%3dparams%26params%3dopenId&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
			window.location.href='https://user.cs96111.com/ad/record/url/auth?data=10;29;1';
		},
		more() {
			this.$router.push('/micro_police')
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/health_dialog/health_dialog.controller.js